"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
const react_1 = require("react");
exports.useAwesomeResourceConfig = (resource) => {
    return react_1.useMemo(() => {
        const p = constants_1.AWESOME_RESOURCE_CONFIG[resource];
        if (!p) {
            throw new Error(`Resource ${resource} is not valid`);
        }
        return p;
    }, [resource]);
};
//# sourceMappingURL=useAwesomeResourceConfig.js.map